import {createContext} from "react";

export const WindowContext = createContext({
    width: 800,
    height: 600,
});